import {
  Box,
  FormControlLabel,
  InputLabel,
  Stack,
  Switch,
  TextField
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import type { CanaryTokenFormFields } from './AdminCanaryTokens.types';

export const AdminCanaryTokensDialogForm: React.FC = () => {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext<CanaryTokenFormFields>();

  return (
    <Stack spacing={2} sx={{ pt: 1 }}>
      <Box>
        <InputLabel id="subscription_id">Token</InputLabel>
        <TextField
          {...register('token')}
          fullWidth
          disabled
          error={!!errors.token}
          helperText={errors.token?.message}
        />
      </Box>
      <Box>
        <InputLabel id="description">Description</InputLabel>
        <TextField
          {...register('description')}
          fullWidth
          multiline
          rows={3}
          placeholder="Enter a description or name for this token"
          error={!!errors.description}
          helperText={errors.description?.message}
        />
      </Box>
      <Box>
        <Controller
          name="active"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  checked={field.value}
                  onChange={field.onChange}
                  color="primary"
                />
              }
              label="Enabled"
            />
          )}
        />
      </Box>
    </Stack>
  );
};

export default AdminCanaryTokensDialogForm;
